// extracted by mini-css-extract-plugin
export default {"table":"AttendanceTable_table__xl4BK","actions":"AttendanceTable_actions__2qk2c"};